import React, { Component } from 'react';
import RiskLineChart from './risk-line-chart';
import { createUUID } from '../../react-flow-pedigree/utils';
import RiskBarChart from './risk-bar-chart';

class RiskAssessmentCharts extends Component {

  constructor(props) {
    super(props);
    this.boadiceaBreastRef = React.createRef();
    this.boadiceaOvarianRef = React.createRef();
    this.clausBreastRef = React.createRef();
    this.gailBreastRef = React.createRef();
    this.tyrerCuzickBreastRef = React.createRef();
    this.brcaProBreastRef = React.createRef();
    this.brcaProOvarianRef = React.createRef();
    this.mmrProColonRef = React.createRef();
    this.mmrProUterineEndometrialRef = React.createRef();
    this.pancProPancreaticRef = React.createRef();
    this.melaProMelanomaRef = React.createRef();
    this.qrisk3CardiovascularRef = React.createRef();
    var showBoadicea = this.props.orgLicense.boadicea;
    var showClaus = false;
    var showGail = false;
    var showTyrerCuzick = false;
    var showBrcapro = false;
    var showMmrpro = false;
    var showPancpro = false;
    var showMelapro = false;
    var showQrisk3 = false;
    if (!showBoadicea) {
      showClaus = this.props.orgLicense.claus;
      if (!showClaus) {
        showGail = this.props.orgLicense.gail;
        if (!showGail) {
          showTyrerCuzick = this.props.orgLicense.tyrer_cuzick;
          if (!showTyrerCuzick) {
            showBrcapro = this.props.orgLicense.brcapro;
            if (!showBrcapro) {
              showMmrpro = this.props.orgLicense.mmrpro;
              if (!showMmrpro) {
                showPancpro = this.props.orgLicense.pancpro;
                if (!showPancpro) {
                  showMelapro = this.props.orgLicense.melapro;
                  if (!showMelapro) {
                    showQrisk3 = this.props.orgLicense.qrisk3;
                  }
                }
              }
            }
          }
        }
      }
    }
    this.state = {
      showBoadiceaChartsTab: showBoadicea,
      showClausChartsTab: showClaus,
      showGailChartsTab: showGail,
      showTyrerCuzickChartsTab: showTyrerCuzick,
      showBrcaproChartsTab: showBrcapro,
      showMmrproChartsTab: showMmrpro,
      showPancproChartsTab: showPancpro,
      showMelaproChartsTab: showMelapro,
      showQrisk3CardiovascularTab: showQrisk3
    };

    this.handleBoadiceaTabClicked  = this.handleBoadiceaTabClicked.bind(this);
    this.handleClausTabClicked = this.handleClausTabClicked.bind(this);
    this.handleGailTabClicked = this.handleGailTabClicked.bind(this);
    this.handleTyrerCuzickTabClicked = this.handleTyrerCuzickTabClicked.bind(this);
    this.handleBrcaproTabClicked = this.handleBrcaproTabClicked.bind(this);
    this.handleMmrproTabClicked = this.handleMmrproTabClicked.bind(this);
    this.handlePancproTabClicked = this.handlePancproTabClicked.bind(this);
    this.handleMelaproTabClicked = this.handleMelaproTabClicked.bind(this);
    this.handleQrisk3CardiovascularTabClicked = this.handleQrisk3CardiovascularTabClicked.bind(this);
    this.showAllRiskAssessmentsForPrint = this.showAllRiskAssessmentsForPrint.bind(this);
  }

  handleBoadiceaTabClicked(event) {
    this.setState({
      showBoadiceaChartsTab: true,
      showClausChartsTab: false,
      showGailChartsTab: false,
      showTyrerCuzickChartsTab: false,
      showBrcaproChartsTab: false,
      showMmrproChartsTab: false,
      showPancproChartsTab: false,
      showMelaproChartsTab: false,
      showQrisk3CardiovascularTab: false
    });
  }

  handleClausTabClicked(event) {
    this.setState({
      showBoadiceaChartsTab: false,
      showClausChartsTab: true,
      showGailChartsTab: false,
      showTyrerCuzickChartsTab: false,
      showBrcaproChartsTab: false,
      showMmrproChartsTab: false,
      showPancproChartsTab: false,
      showMelaproChartsTab: false,
      showQrisk3CardiovascularTab: false
    });
  }

  handleGailTabClicked(event) {
    this.setState({
      showBoadiceaChartsTab: false,
      showClausChartsTab: false,
      showGailChartsTab: true,
      showTyrerCuzickChartsTab: false,
      showBrcaproChartsTab: false,
      showMmrproChartsTab: false,
      showPancproChartsTab: false,
      showMelaproChartsTab: false,
      showQrisk3CardiovascularTab: false
    });
  }

  handleTyrerCuzickTabClicked(event) {
    this.setState({
      showBoadiceaChartsTab: false,
      showClausChartsTab: false,
      showGailChartsTab: false,
      showTyrerCuzickChartsTab: true,
      showBrcaproChartsTab: false,
      showMmrproChartsTab: false,
      showPancproChartsTab: false,
      showMelaproChartsTab: false,
      showQrisk3CardiovascularTab: false
    });
  }

  handleBrcaproTabClicked(event) {
    this.setState({
      showBoadiceaChartsTab: false,
      showClausChartsTab: false,
      showGailChartsTab: false,
      showTyrerCuzickChartsTab: false,
      showBrcaproChartsTab: true,
      showMmrproChartsTab: false,
      showPancproChartsTab: false,
      showMelaproChartsTab: false,
      showQrisk3CardiovascularTab: false
    });
  }

  handleMmrproTabClicked(event) {
    this.setState({
      showBoadiceaChartsTab: false,
      showClausChartsTab: false,
      showGailChartsTab: false,
      showTyrerCuzickChartsTab: false,
      showBrcaproChartsTab: false,
      showMmrproChartsTab: true,
      showPancproChartsTab: false,
      showMelaproChartsTab: false,
      showQrisk3CardiovascularTab: false
    });
  }

  handlePancproTabClicked(event) {
    this.setState({
      showBoadiceaChartsTab: false,
      showClausChartsTab: false,
      showGailChartsTab: false,
      showTyrerCuzickChartsTab: false,
      showBrcaproChartsTab: false,
      showMmrproChartsTab: false,
      showPancproChartsTab: true,
      showMelaproChartsTab: false,
      showQrisk3CardiovascularTab: false
    });
  }

  handleMelaproTabClicked(event) {
    this.setState({
      showBoadiceaChartsTab: false,
      showClausChartsTab: false,
      showGailChartsTab: false,
      showTyrerCuzickChartsTab: false,
      showBrcaproChartsTab: false,
      showMmrproChartsTab: false,
      showPancproChartsTab: false,
      showMelaproChartsTab: true,
      showQrisk3CardiovascularTab: false
    });
  }

  handleQrisk3CardiovascularTabClicked(event) {
    this.setState({
      showBoadiceaChartsTab: false,
      showClausChartsTab: false,
      showGailChartsTab: false,
      showTyrerCuzickChartsTab: false,
      showBrcaproChartsTab: false,
      showMmrproChartsTab: false,
      showPancproChartsTab: false,
      showMelaproChartsTab: false,
      showQrisk3CardiovascularTab: true
    });
  }

  async showAllRiskAssessmentsForPrint(risk_settings, errors){
    this.setState({
      showBoadiceaChartsTab: true,
      showClausChartsTab: true,
      showGailChartsTab: true,
      showTyrerCuzickChartsTab: true,
      showBrcaproChartsTab: true,
      showMmrproChartsTab: true,
      showPancproChartsTab: true,
      showMelaproChartsTab: true,
      showQrisk3CardiovascularTab: true
    }, async() => {
      if (risk_settings.boadicea && Object.keys(errors.boadiceaRuntimeErrors).length === 0) {
        await this.boadiceaBreastRef.current.hideToolbarForPrint();
        await this.boadiceaOvarianRef.current.hideToolbarForPrint();
        await this.boadiceaBreastRef.current.hideLegendForPrint();
        await this.boadiceaOvarianRef.current.hideLegendForPrint();
      }
      if (risk_settings.claus && errors.clausRuntimeErrors.length === 0) {
        await this.clausBreastRef.current.hideToolbarForPrint();
        await this.clausBreastRef.current.hideLegendForPrint();
      }
      if (risk_settings.gail && errors.gailRuntimeErrors.length === 0) {
        await this.gailBreastRef.current.hideToolbarForPrint();
        await this.gailBreastRef.current.hideLegendForPrint();
      }
      if (risk_settings.tyrer_cuzick && errors.tyrerCuzickRuntimeErrors.length === 0) {
        await this.tyrerCuzickBreastRef.current.hideToolbarForPrint();
        await this.tyrerCuzickBreastRef.current.hideLegendForPrint();
      }
      if (risk_settings.brcapro && errors.brcaproRuntimeErrors.length === 0) {
        await this.brcaProBreastRef.current.hideToolbarForPrint();
        await this.brcaProOvarianRef.current.hideToolbarForPrint();
        await this.brcaProBreastRef.current.hideLegendForPrint();
        await this.brcaProOvarianRef.current.hideLegendForPrint();
      }
      if (risk_settings.mmrpro && errors.mmrproRuntimeErrors.length === 0) {
        await this.mmrProColonRef.current.hideToolbarForPrint();
        await this.mmrProUterineEndometrialRef.current.hideToolbarForPrint();
        await this.mmrProColonRef.current.hideLegendForPrint();
        await this.mmrProUterineEndometrialRef.current.hideLegendForPrint();
      }
      if (risk_settings.pancpro && errors.pancproRuntimeErrors.length === 0) {
        await this.pancProPancreaticRef.current.hideToolbarForPrint();
        await this.pancProPancreaticRef.current.hideLegendForPrint();
      }
      if (risk_settings.melapro && errors.melaproRuntimeErrors.length === 0) {
        await this.melaProMelanomaRef.current.hideToolbarForPrint();
        await this.melaProMelanomaRef.current.hideLegendForPrint();
      }
      if (risk_settings.qrisk3_cardiovascular && errors.qrisk3CardiovascularRuntimeErrors.length === 0) {
        await this.qrisk3CardiovascularRef.current.hideToolbarForPrint();
        await this.qrisk3CardiovascularRef.current.hideLegendForPrint();
      }
    });
  }

  render() {
    const boadicea_tab_active = (this.state.showBoadiceaChartsTab) ? 'active' : '';
    const claus_tab_active = (this.state.showClausChartsTab) ? 'active' : '';
    const gail_tab_active = (this.state.showGailChartsTab) ? 'active' : '';
    const tyrer_cuzick_tab_active = (this.state.showTyrerCuzickChartsTab) ? 'active' : '';
    const brcapro_tab_active = (this.state.showBrcaproChartsTab) ? 'active' : '';
    const mmrpro_tab_active = (this.state.showMmrproChartsTab) ? 'active' : '';
    const pancpro_tab_active = (this.state.showPancproChartsTab) ? 'active' : '';
    const melapro_tab_active = (this.state.showMelaproChartsTab) ? 'active' : '';
    const qrisk3_cardiovascular_tab_active = (this.state.showQrisk3CardiovascularTab) ? 'active' : '';

    const boadicea_content_css = (this.state.showBoadiceaChartsTab) ? 'tab-pane active graph-border' : 'tab-pane graph-border';
    const claus_content_css = (this.state.showClausChartsTab) ? 'tab-pane active graph-border' : 'tab-pane graph-border';
    const gail_content_css = (this.state.showGailChartsTab) ? 'tab-pane active graph-border' : 'tab-pane graph-border';
    const tyrer_cuzick_content_css = (this.state.showTyrerCuzickChartsTab) ? 'tab-pane active graph-border' : 'tab-pane graph-border';
    const brcapro_content_css = (this.state.showBrcaproChartsTab) ? 'tab-pane active graph-border' : 'tab-pane graph-border';
    const mmrpro_content_css = (this.state.showMmrproChartsTab) ? 'tab-pane active graph-border' : 'tab-pane graph-border';
    const pancpro_content_css = (this.state.showPancproChartsTab) ? 'tab-pane active graph-border' : 'tab-pane graph-border';
    const melapro_content_css = (this.state.showMelaproChartsTab) ? 'tab-pane active graph-border' : 'tab-pane graph-border';
    const qrisk3_cardiovascular_content_css = (this.state.showQrisk3CardiovascularTab) ? 'tab-pane active graph-border' : 'tab-pane graph-border';

    let claus_breast_chart = null;
    let gail_breast_chart = null;
    let tyrer_cuzick_breast_chart = null;
    let brcapro_breast_chart = null;
    let brcapro_ovarian_chart = null;
    let mmrpro_colon_chart = null;
    let mmrpro_uterine_endometrial_chart = null;
    let pancpro_pancreatic_chart = null;
    let melapro_melanoma_chart = null;
    let qrisk3_cardiovascular_chart = null;

    // BOADICEA CHARTS
    let breast_chart = null;
    let ovarian_chart = null;

    if(this.props.orgLicense.boadicea){
      const chart_type = (this.props.boadiceaCancerRisks.length === 1) ? 'bar' : 'line';

      const breastChartProps = {
        chartId: 'breast-chart',
        title: 'Breast',
        labels: this.props.boadiceaCancerRisks.map((risk) => risk.age),
        payload: [
          {name: "Breast", data: this.props.boadiceaCancerRisks.map((risk) => risk["breast cancer risk"].percent)},
          {name: "Population Breast Cancer Risk", data: this.props.boadiceaPopulationRisks.map((risk) => risk["breast cancer risk"].percent)}
        ],
        chartType: chart_type
      };

      const ovarianChartProps = {
        chartId: 'ovarian-chart',
        title: 'Ovarian',
        labels: this.props.boadiceaCancerRisks.map((risk) => risk.age),
        payload: [
          {name: "Ovarian", data: this.props.boadiceaCancerRisks.map((risk) => risk["ovarian cancer risk"].percent)},
          {name: "Population Ovarian Cancer Risk", data: this.props.boadiceaPopulationRisks.map((risk) => risk["ovarian cancer risk"].percent)}
        ],
        chartType: chart_type
      };

      breast_chart = <RiskLineChart {...breastChartProps} key={createUUID()} ref={this.boadiceaBreastRef}/>;
      ovarian_chart = <RiskLineChart {...ovarianChartProps} key={createUUID()} ref={this.boadiceaOvarianRef}/>;
    } else {
      breast_chart = "No Data Available";
      ovarian_chart = null;
    }

    if(this.props.orgLicense.claus) {
      const chart_type = (this.props.clausCancerRisks.length === 1) ? 'bar' : 'line';

      const breastChartProps = {
        chartId: 'claus-breast-chart',
        title: 'Breast',
        labels: this.props.clausCancerRisks.map((risk) => risk.age),
        payload: [
          {name: "Breast", data: this.props.clausCancerRisks.map((risk) => risk.breast)}
        ],
        chartType: chart_type
      };

      claus_breast_chart = <RiskLineChart {...breastChartProps} key={createUUID()} ref={this.clausBreastRef}/>;
    } else {
      claus_breast_chart = "No Data Available";
    }

    if(this.props.orgLicense.gail) {
      const chart_type = (this.props.gailCancerRisks.length === 1) ? 'bar' : 'line';

      const breastChartProps = {
        chartId: 'gail-breast-chart',
        title: 'Breast',
        labels: this.props.gailCancerRisks.map((risk) => risk.age),
        payload: [
          {name: "Breast", data: this.props.gailCancerRisks.map((risk) => risk.risk_absolute)},
          {name: "Population Breast Cancer Risk", data: this.props.gailCancerRisks.map((risk) => risk.risk_average)}
        ],
        chartType: chart_type
      };

      gail_breast_chart = <RiskLineChart {...breastChartProps} key={createUUID()} ref={this.gailBreastRef}/>;
    } else {
      gail_breast_chart = "No Data Available";
    }

    if(this.props.orgLicense.tyrer_cuzick) {
      const chart_type = (this.props.tyrerCuzickCancerRisks.length === 1) ? 'bar' : 'line';

      const breastChartProps = {
        chartId: 'tyrer-cuzick-breast-chart',
        title: 'Breast',
        labels: this.props.tyrerCuzickCancerRisks.map((risk) => risk.age),
        payload: [
          {name: "Breast", data: this.props.tyrerCuzickCancerRisks.map((risk) => (100.0 * parseFloat(risk.breast.decimal)).toFixed(2))},
          {name: "Population Breast Cancer Risk", data: this.props.tyrerCuzickCancerRisks.map((risk) => (100.0 * parseFloat(risk.breast.populationRisk)).toFixed(2))},
        ],
        chartType: chart_type
      };

      tyrer_cuzick_breast_chart = <RiskLineChart {...breastChartProps} key={createUUID()} ref={this.tyrerCuzickBreastRef}/>;
    } else {
      tyrer_cuzick_breast_chart = "No Data Available";
    }

    if(this.props.orgLicense.brcapro){
      const chart_type = (this.props.brcaproCancerRisks.length === 1) ? 'bar' : 'line';

      const breastChartProps = {
        chartId: 'brcapro-breast-chart',
        title: 'Breast',
        labels: this.props.brcaproCancerRisks.map((risk) => risk.age),
        payload: [
          {name: "Breast", data: this.props.brcaproCancerRisks.map((risk) => risk["breast"].percent.toFixed(2))}
        ],
        chartType: chart_type
      };

      const ovarianChartProps = {
        chartId: 'brcapro-ovarian-chart',
        title: 'Ovarian',
        labels: this.props.brcaproCancerRisks.map((risk) => risk.age),
        payload: [
          {name: "Ovarian", data: this.props.brcaproCancerRisks.map((risk) => risk["ovarian"].percent.toFixed(2))}
        ],
        chartType: chart_type
      };

      brcapro_breast_chart = <RiskLineChart {...breastChartProps} key={createUUID()} ref={this.brcaProBreastRef}/>;
      brcapro_ovarian_chart = <RiskLineChart {...ovarianChartProps} key={createUUID()} ref={this.brcaProOvarianRef}/>;
    } else {
      brcapro_breast_chart = "No Data Available";
      brcapro_ovarian_chart = null;
    }

    if(this.props.orgLicense.mmrpro){
      const chart_type = (this.props.mmrproCancerRisks.length === 1) ? 'bar' : 'line';

      const colonChartProps = {
        chartId: 'colon-chart',
        title: 'Colon',
        labels: this.props.mmrproCancerRisks.map((risk) => risk.age),
        payload: [
          {name: "Colon", data: this.props.mmrproCancerRisks.map((risk) => risk["colon"].percent.toFixed(2))}
        ],
        chartType: chart_type
      };

      const uterineEndometrialChartProps = {
        chartId: 'uterine-endometrial-chart',
        title: 'Uterine/Endometrial',
        labels: this.props.mmrproCancerRisks.map((risk) => risk.age),
        payload: [
          {name: "Uterine/Endometrial", data: this.props.mmrproCancerRisks.map((risk) => risk["uterine_endometrial"].percent.toFixed(2))}
        ],
        chartType: chart_type
      };

      mmrpro_colon_chart = <RiskLineChart {...colonChartProps} key={createUUID()} ref={this.mmrProColonRef}/>;
      mmrpro_uterine_endometrial_chart = <RiskLineChart {...uterineEndometrialChartProps} key={createUUID()} ref={this.mmrProUterineEndometrialRef}/>;
    } else {
      mmrpro_colon_chart = "No Data Available";
      mmrpro_uterine_endometrial_chart = null;
    }

    if(this.props.orgLicense.pancpro){
      const chart_type = (this.props.pancproCancerRisks.length === 1) ? 'bar' : 'line';

      const pancreaticChartProps = {
        chartId: 'pancreatic-chart',
        title: 'Pancreatic',
        labels: this.props.pancproCancerRisks.map((risk) => risk.age),
        payload: [
          {name: "Pancreatic", data: this.props.pancproCancerRisks.map((risk) => risk["pancreatic"].percent.toFixed(2))}
        ],
        chartType: chart_type
      };

      pancpro_pancreatic_chart = <RiskLineChart {...pancreaticChartProps} key={createUUID()} ref={this.pancProPancreaticRef}/>;
    } else {
      pancpro_pancreatic_chart = "No Data Available";
    }

    if(this.props.orgLicense.melapro){
      const chart_type = (this.props.melaproCancerRisks.length === 1) ? 'bar' : 'line';

      const melanomaChartProps = {
        chartId: 'melanoma-chart',
        title: 'Melanoma',
        labels: this.props.melaproCancerRisks.map((risk) => risk.age),
        payload: [
          {name: "Melanoma", data: this.props.melaproCancerRisks.map((risk) => risk["melanoma"].percent.toFixed(2))}
        ],
        chartType: chart_type
      };

      melapro_melanoma_chart = <RiskLineChart {...melanomaChartProps} key={createUUID()} ref={this.melaProMelanomaRef}/>;
    } else {
      melapro_melanoma_chart = "No Data Available";
    }

    if(this.props.orgLicense.qrisk3){
      const chart_type = 'bar';

      if (this.props.qrisk3CancerRisks.cardiovascular.tenYear && this.props.qrisk3CancerRisks.cardiovascular.tenYear !== 'N/A'
        && this.props.qrisk3CancerRisks.cardiovascular.average && this.props.qrisk3CancerRisks.cardiovascular.average !== 'N/A'
      ) {
        const cardiovascularChartProps = {
          chartId: 'cardiovascular-chart',
          title: 'Cardiovascular',
          labels: ['Patient', 'Average'],
          payload: [
            {
              name: "Cardiovascular Risk", 
              data: [this.props.qrisk3CancerRisks.cardiovascular.tenYear,this.props.qrisk3CancerRisks.cardiovascular.average]
            }
          ],
          chartType: chart_type
        };

        qrisk3_cardiovascular_chart = <RiskBarChart {...cardiovascularChartProps} key={createUUID()} ref={this.qrisk3CardiovascularRef}/>;
      }
    } else {
      qrisk3_cardiovascular_chart = "No Data Available";
    }

    let risk_categories = ["Near population risk", "Moderate risk", "High risk"];
    let risk_category2080 = null;
    let risk_category4050 = null;
    let risk_value2080 = null;
    let risk_value4050 = null;
    let risk_class2080 = null;
    let risk_class4050 = null;

    // currently there should be two arrays within Nice Risk Results
    // one for age 20 risk and one for age 40 risk
    if (this.props.niceRiskResults && 
      this.props.niceRiskResults.length === 2 && 
      Array.isArray(this.props.niceRiskResults[0]) &&
      Array.isArray(this.props.niceRiskResults[1]) &&
      this.props.niceRiskResults[0].length > 0 &&
      this.props.niceRiskResults[1].length > 0) {
      let age_20_risk = this.props.niceRiskResults[0]
      let age_40_risk = this.props.niceRiskResults[1]
      let age20Object = age_20_risk.find(item => item.age === 21);
      let lifetimeObject = age_20_risk.find(item => item.age === 80);
      let age50Object = age_40_risk.find(item => item.age === 50);
      risk_value2080 = Math.round((lifetimeObject["breast cancer risk"].decimal - age20Object["breast cancer risk"].decimal) * 1000) / 10;
      risk_value4050 = age50Object["breast cancer risk"].percent
    }

    if (risk_value2080 < 17) {
      risk_category2080 = risk_categories[0];
      risk_class2080 = "alert alert-success";
    } else if (risk_value2080 >= 17 && risk_value2080 < 30) {
      risk_category2080 = risk_categories[1];
      risk_class2080 = "alert alert-warning";
    } else {
      risk_category2080 = risk_categories[2];
      risk_class2080 = "alert alert-danger";
    }

    if (risk_value4050 < 3) {
      risk_category4050 = risk_categories[0];
      risk_class4050 = "alert alert-success";
    } else if (risk_value4050 >= 3 && risk_value4050 <= 8) {
      risk_category4050 = risk_categories[1];
      risk_class4050 = "alert alert-warning";
    } else {
      risk_category4050 = risk_categories[2];
      risk_class4050 = "alert alert-danger";
    }

    return (
      <div>
        {this.props.orgLicense && (
        <ul className="nav nav-tabs">
          {this.props.orgLicense.boadicea && (
            <li className={boadicea_tab_active}><button className="btn-link" onClick={this.handleBoadiceaTabClicked}>BOADICEA</button></li>
          )}
          {this.props.orgLicense.claus && (
            <li className={claus_tab_active}><button className="btn-link" onClick={this.handleClausTabClicked}>CLAUS</button></li>
          )}
          {this.props.orgLicense.gail && (
            <li className={gail_tab_active}><button className="btn-link" onClick={this.handleGailTabClicked}>GAIL</button></li>
          )}
          {this.props.orgLicense.tyrer_cuzick && (
            <li className={tyrer_cuzick_tab_active}><button className="btn-link" onClick={this.handleTyrerCuzickTabClicked}>TYRER-CUZICK</button></li>
          )}
          {this.props.orgLicense.brcapro && (
            <li className={brcapro_tab_active}><button className="btn-link" onClick={this.handleBrcaproTabClicked}>BRCAPRO</button></li>
          )}
          {this.props.orgLicense.mmrpro && (
            <li className={mmrpro_tab_active}><button className="btn-link" onClick={this.handleMmrproTabClicked}>MMRPRO</button></li>
          )}
          {this.props.orgLicense.pancpro && (
            <li className={pancpro_tab_active}><button className="btn-link" onClick={this.handlePancproTabClicked}>PANCPRO</button></li>
          )}
          {this.props.orgLicense.melapro && (
            <li className={melapro_tab_active}><button className="btn-link" onClick={this.handleMelaproTabClicked}>MELAPRO</button></li>
          )}
          {this.props.orgLicense.qrisk3 && (
            <li className={qrisk3_cardiovascular_tab_active}><button className="btn-link" onClick={this.handleQrisk3CardiovascularTabClicked}>QRISK3</button></li>
          )}
        </ul>
        )}

        {this.props.orgLicense.boadicea && (
          <div className="tab-content">
            <div className={boadicea_content_css} id="boadicea-tab-content" style={{position: 'relative'}}>
              {risk_value2080 && (
                <div class={risk_class2080} role="alert">
                  Breast cancer risk age 20-80: {risk_value2080}% {risk_category2080} (NICE Guideline CG164)
                </div>
              )}
              {risk_value4050 && (
                <div class={risk_class4050} role="alert">
                  Breast cancer risk age 40-50: {risk_value4050}% {risk_category4050} (NICE Guideline CG164)
                </div>
              )}
              <div id="boadicea-tab-content-breast">{breast_chart}</div>

              <div id="boadicea-tab-content-ovarian">{ovarian_chart}</div>
            </div>
          </div>
        )}

        {this.props.orgLicense.claus && (
          <div className="tab-content">
            <div className={claus_content_css} id="claus-tab-content" style={{position: 'relative'}}>
              {claus_breast_chart}
            </div>
          </div>
        )}

        {this.props.orgLicense.gail && (
          <div className="tab-content">
            <div className={gail_content_css} id="gail-tab-content" style={{position: 'relative'}}>
              {gail_breast_chart}
            </div>
          </div>
        )}

        {this.props.orgLicense.tyrer_cuzick && (
          <div className="tab-content">
            <div className={tyrer_cuzick_content_css} id="tyrer-cuzick-tab-content" style={{position: 'relative'}}>
              {tyrer_cuzick_breast_chart}
            </div>
          </div>
        )}

        {this.props.orgLicense.brcapro && (
          <div className="tab-content">
            <div className={brcapro_content_css} id="brcapro-tab-content" style={{position: 'relative'}}>
              <div id="brcapro-tab-content-breast">{brcapro_breast_chart}</div>

              <div id="brcapro-tab-content-ovarian">{brcapro_ovarian_chart}</div>
            </div>
          </div>
        )}

        {this.props.orgLicense.mmrpro && (
          <div className="tab-content">
            <div className={mmrpro_content_css} id="mmrpro-tab-content" style={{position: 'relative'}}>
              <div id="mmrpro-tab-content-colon">{mmrpro_colon_chart}</div>

              <div id="mmrpro-tab-content-uterine-endometrial">{mmrpro_uterine_endometrial_chart}</div>
            </div>
          </div>
        )}

        {this.props.orgLicense.pancpro && ( 
          <div className="tab-content">
            <div className={pancpro_content_css} id="pancpro-tab-content" style={{position: 'relative'}}>
              {pancpro_pancreatic_chart}
            </div>
          </div>
        )}

        {this.props.orgLicense.melapro && (
          <div className="tab-content">
            <div className={melapro_content_css} id="melapro-tab-content" style={{position: 'relative'}}>
              {melapro_melanoma_chart}
            </div>
          </div>
        )}

        {this.props.orgLicense.qrisk3 && (
          <div className="tab-content">
            <div className={qrisk3_cardiovascular_content_css} id="qrisk3-cardiovascular-tab-content" style={{position: 'relative'}}>
              {qrisk3_cardiovascular_chart}
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default RiskAssessmentCharts;
